import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { strictFetcher } from './strict-fetcher'

/// One live `get_dy` answer from the frBTC ⇄ frUSD curve pool, at the REAL
/// trade size (fee-inclusive by construction — CryptoSwap's dynamic fee is
/// inside the number, unlike the AMM quotes that subtract a router fee
/// client-side). `spotOut` is the same amount at the pool's small-probe
/// marginal, so impact renders as (1 − out/spot) without a second request.
export interface CurveQuote {
	sell: string
	amountIn: bigint
	amountOut: bigint
	spotOut: bigint | null
}

export default function useCurveQuote(
	sellId: string | null,
	amountIn: bigint | null
): CurveQuote | null {
	const key =
		sellId && amountIn !== null && amountIn > 0n
			? `${API_URL}/alkane/curve/quote?sell=${encodeURIComponent(sellId)}&amount_in=${amountIn}`
			: null
	const { data } = useSwr<{
		sell: string
		amount_in: string
		amount_out: string
		spot_out: string | null
	}>(key, strictFetcher, {
		refreshInterval: 15_000,
		revalidateOnFocus: false,
		keepPreviousData: false
	})
	if (!data) {
		return null
	}
	try {
		return {
			sell: data.sell,
			amountIn: BigInt(data.amount_in),
			amountOut: BigInt(data.amount_out),
			spotOut: data.spot_out ? BigInt(data.spot_out) : null
		}
	} catch {
		return null
	}
}
